import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HelpBodyGoals() {
    return (
        <OnboardingBody title='What are goals?'>
            <div>
                <p>
                    Every stage should have a clearly-defined goal. When that goal has been met,
                    Nutshell will automatically move a lead to the next stage.
                </p>
                <p>
                    A great sales process has very specific goals for each stage. It should be less
                    about your team’s gut, and more about verifiable evidence from your lead!
                </p>
            </div>
        </OnboardingBody>
    );
}
